import { render, staticRenderFns } from "./UpcomingSiteVisits.vue?vue&type=template&id=1564f010&scoped=true&"
import script from "./UpcomingSiteVisits.vue?vue&type=script&lang=js&"
export * from "./UpcomingSiteVisits.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingSiteVisits.vue?vue&type=style&index=0&id=1564f010&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564f010",
  null
  
)

export default component.exports